var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilePicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "profile picture"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 16,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 41.5556C44 44.992 37.732 46 30 46C22.268 46 16 44.992 16 41.5556C16 38.1191 22.268 33.5556 30 33.5556C37.732 33.5556 44 38.1191 44 41.5556Z",
    stroke: "#29185E",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 21.1111C37 25.0385 33.866 28.2222 30 28.2222C26.134 28.2222 23 25.0385 23 21.1111C23 17.1838 26.134 14 30 14C33.866 14 37 17.1838 37 21.1111Z",
    stroke: "#29185E",
    strokeWidth: 1.75
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePicture);
export default __webpack_public_path__ + "static/media/profile-picture.48d9c785dadcf17ac563c81ad8fbdf5c.svg";
export { ForwardRef as ReactComponent };